import template from './landing-messages.component.html';
import controller from './landing-messages.controller';

const landingMessages = {
  controller,
  template,
};

export default landingMessages;
